import PropTypes from 'prop-types';

// "Actuaciones recientes · Recibidas del PJUD" — the scraper feed. Models the
// four states: carga (skeleton), error, vacío, and the table. Rows open the
// related causa.
export default function ActuacionesFeed({ state, rows }) {
  if (state === 'error') {
    return (
      <div className="dash-feed__error">
        <div className="dash-feed__error-t">
          No pudimos cargar las actuaciones del PJUD.
        </div>
        <div className="note" style={{ marginTop: 6 }}>
          Reintentaremos en breve.
        </div>
      </div>
    );
  }

  if (state === 'loading') {
    return (
      <table className="dash-feed">
        <tbody>
          {Array.from({ length: 5 }).map((_, i) => (
            <tr key={i}>
              <td style={{ width: '26%' }}>
                <span className="dash-feed__skel" style={{ width: '70%' }} />
              </td>
              <td>
                <span
                  className="dash-feed__skel"
                  style={{ width: `${60 + ((i * 11) % 35)}%` }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  if (state === 'empty' || rows.length === 0) {
    return (
      <div className="dash-feed__empty">
        <div className="dash-feed__empty-t">Sin actuaciones nuevas</div>
        <div className="note" style={{ marginTop: 6 }}>
          Vigilamos tus causas en el PJUD y te avisamos cuando llegue una.
        </div>
      </div>
    );
  }

  return (
    <table className="dash-feed">
      <tbody>
        {rows.map((r) => (
          <tr key={r.key} onClick={r.onClick}>
            <td style={{ width: '26%' }}>
              <span className="dash-feed__id">
                {r.unread && <span className="unread-dot" />}
                {r.id}
              </span>
            </td>
            <td>
              <div className="dash-feed__primary">{r.primary}</div>
              {r.secondary && (
                <div className="dash-feed__secondary">{r.secondary}</div>
              )}
            </td>
            <td className="dash-feed__date" style={{ width: '16%' }}>
              {r.date}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

ActuacionesFeed.propTypes = {
  state: PropTypes.oneOf(['loading', 'error', 'empty', 'ready']).isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      id: PropTypes.string,
      unread: PropTypes.bool,
      primary: PropTypes.node,
      secondary: PropTypes.node,
      date: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ).isRequired,
};
